<h3 mat-dialog-title style="text-align: center">{{ 'titles.change-username' | translate }}</h3>
<mat-dialog-content>
  <div fxLayout="column" style="margin-top: 5px" fxLayoutGap="10px">
    <form
      fxLayout="column"
      fxLayoutGap="10px"
      style="margin-top: 5px"
      fxFlex
      [formGroup]="changeUserName"
      (ngSubmit)="onOkPressed()"
      novalidate
    >
      <div [innerHTML]="'misc.change-username-for-non-local-user' | translate: { userName: data.userName }"></div>
      <mat-form-field>
        <mat-label>{{ 'labels.enter-name' | translate }}</mat-label>
        <input test-id="enter-username" type="text" matInput formControlName="userName" />
        @if (changeUserName.controls.userName.hasError('required')) {
          <mat-error>
            {{ 'errors.name-missing' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div fxFlex fxLayout="row" fxLayoutAlign="end center">
    <button test-id="ok" (click)="onOkPressed()" [disabled]="changeUserName.invalid" mat-raised-button cdkFocusInital>
      {{ 'buttons.ok' | translate }}
    </button>
    <button test-id="cancel" (click)="onCancel()" mat-raised-button>
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>
</mat-dialog-actions>
